import pluralize from 'pluralize';

type SearchResultsNumberProps = {
  total?: number;
  location?: string;
};

export const SearchResultsNumber = ({ total, location }: SearchResultsNumberProps) =>
  total ? (
    <div className="truncate ads:text-secondary text-14 text-gray-11" data-testid="SEARCH_RESULTS_TEXT">
      <span className="font-semibold">
        {total.toLocaleString()}&nbsp;
        {pluralize('result', total)}
      </span>
      {!!location && (
        <span>
          {` `}in {location}
        </span>
      )}
    </div>
  ) : null;
